import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from "./dashboard/dashboard.component";
import {AuthviewComponent} from "./authview/authview.component";
import {AuthGuard} from "./_guards/auth.guard";
import {LoginComponent} from "./login/login.component";
import {NotfoundComponent} from "./notfound/notfound.component";
import {UnauthviewComponent} from "./unauthview/unauthview.component";
import {ContactComponent} from "./contact/contact.component";
import {TermsComponent} from "./terms/terms.component";
import {PrivacyComponent} from "./privacy/privacy.component";
import {FeedComponent} from "./feed/feed.component";
import {roleGuard} from './_guards/role.guard';
import {PasswordResetComponent} from "./password-reset/password-reset.component";
import {InviteAcceptComponent} from "./invite-accept/invite-accept.component";
import {userAnswerForCommunityQuestionsGuard} from './_guards/user-answer-for-community-questions.guard';
import {CommunityDynamicPageComponent} from "./shared/community-dynamic-page/community-dynamic-page.component";
import {ReportsComponent} from "./admin/reports/reports.component";
import {emailVerifiedGuard} from './_guards/email-verified.guard';
import {EmailVerifiedComponent} from './shared/email-verified/email-verified.component';
import {LoadingComponent} from "./shared/loading/loading.component";
import {RouteGuard} from "./_guards/route-guard.guard";
import {CommunicationPreferencesComponent} from "./communication-preferences/communication-preferences.component";
import {PassthroughComponent} from "./passthrough/passthrough.component";
import {ProfileQuestionsComponent} from "./shared/profile-questions/profile-questions.component";
import {PollembedComponent} from "./shared/pollembed/pollembed.component";
import {customHomePageGuard} from "./_guards/custom-home-page.guard";


const routes: Routes = [
    {path: '', pathMatch: 'full', component: LoadingComponent, canActivate: [customHomePageGuard]},
    {
        path: '', component: UnauthviewComponent, children: [
            {path: 'login', component: LoginComponent, title: 'Login'},
            {path: '404', component: NotfoundComponent, title: '404 Not Found'},
            {
                path: 'communicationPreferences',
                component: CommunicationPreferencesComponent,
                title: 'Communication Preferences'
            }, {
                path: 'communication-preferences',
                component: CommunicationPreferencesComponent,
                title: 'Communication Preferences'
            },
            {path: 'contact', component: ContactComponent, title: 'Contact Us'},
            {path: 'contact-information', component: ContactComponent, title: 'Contact Us'},
            {path: 'terms-and-conditions', component: TermsComponent, title: 'Terms & Conditions'},
            {path: 'privacy-policy', component: PrivacyComponent, title: 'Privacy Policy'},
            {path: 'info/:id', component: CommunityDynamicPageComponent, title: 'Info'},
            {path: 'password/reset/:token', component: PasswordResetComponent, title: 'Password Reset'},
            {path: 'invite/:token', component: InviteAcceptComponent, title: 'Password Reset'},
            {path: 'poll/:id/:token', component: PollembedComponent, title: 'Poll'},
        ]
    },

    {
        path: '', component: AuthviewComponent, children: [
            {path: 'dashboard', component: DashboardComponent, title: 'Dashboard'},
            {path: 'feed', component: FeedComponent, title: 'Feed'},
            {path: 'feed/:post', component: FeedComponent, title: 'Feed'},
            {path: 'dashboard/:comment', component: DashboardComponent, title: 'Dashboard'},
            {path: 'dashboard/:comment/:reply', component: DashboardComponent, title: 'Dashboard'},
        ], canActivate: [AuthGuard, emailVerifiedGuard, userAnswerForCommunityQuestionsGuard],
    },

    {
        path: 'profile-questions',
        component: ProfileQuestionsComponent,
        title: 'Update Profile',
        canActivate: [AuthGuard, emailVerifiedGuard]
    },

    {
        path: '', component: AuthviewComponent, children: [
            {path: 'reports', component: ReportsComponent, title: 'Reports'},
        ],
        canActivate: [AuthGuard, emailVerifiedGuard, roleGuard],
        data: {
            communityRoles: ['reports_only']
        }
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthGuard, emailVerifiedGuard, roleGuard],
        data: {
            communityRoles: ['full_admin']
        }
    },
    {
        path: 'verify',
        component: EmailVerifiedComponent,
        title: 'Email Verification Required',
        canActivate: [AuthGuard]
    },
    {
        path: 'verify/:token',
        component: EmailVerifiedComponent,
        title: 'Email Verification Required',
        canActivate: [AuthGuard]
    },
    {path: '404', component: NotfoundComponent, title: '404 NOT FOUND'},
    {path: 'passthrough', component: PassthroughComponent, title: 'Loading'},
    {path: '**', component: LoadingComponent, canActivate: [RouteGuard]}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
